import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Box, Button, Collapse, TextField } from "@mui/material";
import { type FC, useState } from "react";

/** The optional note that rides along with sending for review, or with any review status change. */
export const ReviewMessageField: FC<{
  label: string;
  value: string;
  onChange: (message: string) => void;
}> = ({ label, value, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Button
        variant="text"
        data-analytics-id="moment-review-message-toggle"
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={() => setOpen((shown) => !shown)}
        aria-expanded={open}
      >
        {label}
      </Button>
      <Collapse in={open}>
        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Add a message (optional)"
          placeholder="Let me know what you think of this..."
          value={value}
          onChange={(event) => onChange(event.target.value)}
          sx={{ mt: 1 }}
        />
      </Collapse>
    </Box>
  );
};
